import { defineCookie } from '@/features/shared/utils/defineCookie'
import { guestStoreSchema } from '@/features/account/services/GuestUser/schemas'

export const USER_STORE_COOKIE = 'user_store'

// store selected by a signed in user who has no shopping address yet.
export const userStoreCookie = defineCookie({
  name: USER_STORE_COOKIE,
  schema: guestStoreSchema.optional(),
  fallback: undefined,
})
